let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kNFvF"), load("fliVL"), load("dAq7W")]).then(() => parcelRequire('1jMgA'));